<template>
	<div class="bg-white p-4 rounded-lg shadow-md flex items-center space-x-3">
		<div :class="[iconClass, 'p-2 rounded-full']">
			<q-icon v-if="iconType === 'players'" name="person_outline" size="28px" />
			<q-icon v-else-if="iconType === 'winners'" name="emoji_events" size="28px" />
			<q-icon v-else-if="iconType === 'winrate'" name="trending_up" size="28px" />
			<q-icon v-else-if="iconType === 'gameweeks'" name="calendar_month" size="28px" />
		</div>

		<div>
			<p class="text-xl font-bold text-gray-800">{{ value }}</p>
			<p class="text-sm text-gray-500">{{ title }}</p>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	iconType: {
		type: String, // 'players', 'winners', 'winrate', 'gameweeks'
		required: true,
	},
	title: String,
	value: [String, Number],
});

const iconClass = computed(() => {
	switch (props.iconType) {
		case 'players':
			return 'bg-blue-100 text-blue-600';
		case 'winners':
			return 'bg-green-100 text-green-600';
		case 'winrate':
			return 'bg-purple-100 text-purple-600';
		case 'gameweeks':
			return 'bg-yellow-100 text-yellow-600';
		default:
			return 'bg-gray-100 text-gray-600';
	}
});
</script>